// src/branding.js

export const Colors = {
  primaryBlue: "#034e7b",
  logoYellow: "#f7ce0b",
  lightGray: "#f5f5f5",
  white: "#ffffff",
  textDark: "#222222",
};

export const Shadows = {
  card: "0 8px 30px rgba(0,0,0,0.15)",
  soft: "0 4px 12px rgba(0,0,0,0.10)",
};

export const Radii = {
  small: "6px",
  medium: "10px",
  large: "16px",
};

export const Fonts = {
  title: {
    fontSize: "28px",
    fontWeight: "700",
    color: Colors.primaryBlue,
  },
  sectionTitle: {
    fontSize: "22px",
    fontWeight: "700",
    color: Colors.primaryBlue,
  },
  label: {
    fontWeight: "600",
    color: Colors.primaryBlue,
  },
};

export const Layout = {
  page: {
    background: "linear-gradient(135deg, #e3f2fd, #fce4ec)",
    minHeight: "100vh",
    padding: "30px",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    width: "1200px",
    background: Colors.white,
    padding: "30px",
    borderRadius: Radii.large,
    boxShadow: Shadows.card,
  },
};

export const FieldWidths = {
  formField: "600px",   // consistent width for search, comments, login ID
};